module.exports = __webpack_public_path__ + "img/edit.400afca3.svg";